import { useState, useEffect } from "react";
import { Calendar } from "react-multi-date-picker";
import {
  weekDaysArray,
  months,
  dateRange,
} from "utils/constants/onboardingStep";

const MobileDatePicker = ({
  showButtons,
  handleDatePicker,
  selectedValue,
  disableMonthYearPicker,
  isRendered,
}) => {
  const [date, setDate] = useState();

  useEffect(() => {
    const tomorrow = new Date();
    tomorrow?.setDate(tomorrow?.getDate() + 6);
    setDate(selectedValue ? new Date(selectedValue) : tomorrow);
  }, []);

  const handleDateChange = (newDate) => {
    setDate(newDate);
    handleDatePicker(newDate);
  };

  return (
    <Calendar
      highlightToday={true}
      value={date}
      onChange={handleDateChange}
      buttons={showButtons}
      weekDays={weekDaysArray}
      months={months}
      disableYearPicker={disableMonthYearPicker}
      disableMonthPicker={disableMonthYearPicker}
      multiple={false}
      monthYearSeparator={" "}
      minDate={dateRange?.minSelectableDate}
      maxDate={dateRange?.maxSelectableDate}
    />
  );
};

export default MobileDatePicker;
